import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    lat: Number,
    lng: Number,
    zoom: Number
  }

  connect() {
    this.latValue = this.latValue || 48.8740408
    this.lngValue = this.lngValue || 2.34274860000005
    this.zoomValue = this.zoomValue || 16

    this.apiKey = "AIzaSyCAQTqBgQa_pYkw7VxNJqdhtXwH5wHCKwc"

    this.loadGoogleMapsScript()
  }

  loadGoogleMapsScript() {
    if (window.google && window.google.maps) {
      this.initializeMap()
      return
    }

    if (document.querySelector('script[src*="maps.googleapis.com"]')) {
      return
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&callback=initMap`

    window.initMap = () => {
      this.initializeMap()
    }

    document.head.appendChild(script)
  }

  initializeMap() {
    const myLatlng = new google.maps.LatLng(this.latValue, this.lngValue)

    const myOptions = {
      zoom: this.zoomValue,
      center: myLatlng,
      scrollwheel: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
        {"featureType":"landscape","elementType":"labels","stylers":[{"visibility":"off"}]},
        {"featureType":"transit","elementType":"labels","stylers":[{"visibility":"off"}]},
        {"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},
        {"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]},
        {"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},
        {"stylers":[{"hue":"#00aaff"},{"saturation":-100},{"gamma":2.15},{"lightness":12}]},
        {"featureType":"road","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"lightness":24}]},
        {"featureType":"road","elementType":"geometry","stylers":[{"lightness":57}]}
      ]
    }

    const map = new google.maps.Map(this.element, myOptions)
    const marker = new google.maps.Marker({
      position: myLatlng,
      map: map,
      title: "Bien Élevé - 47 rue Richer 75009 Paris"
    })
  }
}
